import React, { useEffect, useState } from "react";
import { Alert, Box } from "@mui/material";
import { useParams } from "react-router-dom";
import MeetingWithWhiteboard from "../../components/MeetingWithWhiteboard";
import api from "../../api";

/**
 * Student live class: same Jitsi + Excalidraw whiteboard as the tutor meeting.
 * Students never record; whiteboard shares the class room_code.
 */
export default function StudentMeetingPage() {
  const { roomCode } = useParams();
  const code = roomCode || "";

  const displayName = (() => {
    try {
      const data = localStorage.getItem("userData");
      return data ? JSON.parse(data).full_name || "Student" : "Student";
    } catch {
      return "Student";
    }
  })();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [jwt, setJwt] = useState(null);
  const [name, setName] = useState(displayName);
  const [drawingEnabled, setDrawingEnabled] = useState(true);

  useEffect(() => {
    if (!code) {
      setLoading(false);
      setError("Missing room code.");
      return;
    }
    let cancelled = false;
    setLoading(true);
    api
      .get(`classroom/join/${encodeURIComponent(code)}`)
      .then((res) => {
        if (cancelled) return;
        const payload = res.data?.jitsi;
        if (payload?.display_name) setName(payload.display_name);
        setJwt(payload?.jwt || null);
        const enabled = res.data?.classroom?.drawing_enabled;
        if (typeof enabled === "boolean") setDrawingEnabled(enabled);
      })
      .catch((e) => {
        if (cancelled) return;
        setError(e?.response?.data?.message || "Could not join this class.");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [code]);

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  return (
    <MeetingWithWhiteboard
      roomCode={code}
      displayName={name}
      canRecord={false}
      autoStartRecording={false}
      recordingMode="local"
      jwt={jwt}
      isModerator={false}
      drawingEnabled={drawingEnabled}
      isTeacher={false}
      loading={loading}
      leavePath="/student/classes"
      meetingLabel="Class"
    />
  );
}
